import { CodeBlock } from '@atlaskit/code';
import { Stack } from '@atlaskit/primitives';
import { IconCardGroup } from '@af/design-system-docs-ui';
import { GuidanceCard } from "../../../../src/components/guidance-cards/guidance-cards";
import { guidanceCardComponents } from "../../../../src/components/guidance-cards/guidance-card-content";
import { contactUsCardsInternalDev } from "../../../../src/pages/contact-us";
import { codeComposingComponents, codeRecommended, codeBadExample1, codeBadExample2 } from "../../../../src/snippets/code/composition";
import * as React from 'react';
export default {
  CodeBlock,
  Stack,
  IconCardGroup,
  GuidanceCard,
  guidanceCardComponents,
  contactUsCardsInternalDev,
  codeComposingComponents,
  codeRecommended,
  codeBadExample1,
  codeBadExample2,
  React
};